var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5a8ca2d0c5ad010c41c738cd106dd95f.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6a04950a3d7a31cb2ea8e5af579b7f86.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/eeec71b8f397ff0be0f10dc5f5e2e4dc.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    